/**
 * @voltxampere/ui — 2N3904 NPN BJT variant (Sprint 38-1)
 *
 * Datasheet-named BJT preset. Generic NPN visual (npn.ts SVG reuse)
 * + 2N3904 datasheet parameter profile.
 *
 * Reference: onsemi NSC4 datasheet 2N3904 (TO-92 small-signal NPN).
 *   Is = 6.7e-15 A      (transport saturation current)
 *   Bf = 300            (forward β at I_C = 10 mA)
 *   Vaf = 74 V          (forward Early voltage)
 *
 * Engine zero-diff invariant honored — this variant maps to the
 * canonical `bjt-npn` engine stamp via `schemaType`. No new engine
 * type registered; the existing Sprint 7 NPN stamp consumes the
 * datasheet params.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const bjtNpn2n3904 = {
    id: "2n3904",
    nameTr: "2N3904 (NPN, TO92)",
    nameEn: "2N3904 (NPN, TO92)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "2N3904",
    schemaType: "bjt-npn",
    defaultParams: { Is: 6.7e-15, Bf: 300, Vaf: 74 },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=bjt-npn-2n3904.js.map